export default __webpack_public_path__ + "static/media/ride.8c8193b1.svg";